<div class="modal-header">
  <h4 class="col-11 modal-title" id="myModalLabel">
    <img alt="Brand" src="{{directoryImages}}/assets/images/dhl-official2.png">
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form (ngSubmit)="search()">
  <div class="modal-body">
    <div class="col-12" style="padding-bottom: 20px;">
      {{messageNumberConflict}}
    </div>
    <div class="form-group offset-sm-4 col-sm-4">
      <input class="form-control" [(ngModel)]="zipCode" name="zipCode" maxlength="9">
    </div>
  </div>
  <div class="modal-footer btnSentStatus">
    <div class="offset-sm-2 col-sm-8 d-grid" style="margin-bottom:5px;padding-top:10px;">
      <button class="btn btn-default btn-block">
        {{'Shared.Search' | translate}}
      </button>
    </div>
  </div>
</form>